module.exports = __webpack_public_path__ + "static/media/CRO.7448e300.svg";